import React, { useState } from 'react';
import axios from 'axios';

const API_KEY = 'AIzaSyAUgoUZT3gxQLfGaLu9vm77P_drGev6KTc'; // Replace this
const CX = 'c01fea9486d8d4545';    // Replace this

/**
 * 
 * https://programmablesearchengine.google.com/controlpanel/lookandfeel?cx=c01fea9486d8d4545
 * https://developers.google.com/custom-search/v1/using_rest#response_data
 * https://developers.google.com/custom-search/v1/reference/rest/v1/cse/list?apix=true
 * https://cse.google.com/cse?cx=c01fea9486d8d4545#gsc.tab=0
 * 
 * Search engine name : NexintainImageSearchEngine
 * 
 * Search engine ID : c01fea9486d8d4545
 * 
 * Public URL : https://cse.google.com/cse?cx=c01fea9486d8d4545
 * 
 * Code : 
    <script async src="https://cse.google.com/cse.js?cx=c01fea9486d8d4545">
    </script>
    <div class="gcse-searchresults-only"></div>
 * 
    API Key : AIzaSyAUgoUZT3gxQLfGaLu9vm77P_drGev6KTc
 * 
 * GOOGLE_IMAGE_SEARCH_BASE_URL : https://www.googleapis.com/customsearch/v1
 * 
 * ENDPOINT : https://www.googleapis.com/customsearch/v1?key=AIzaSyAUgoUZT3gxQLfGaLu9vm77P_drGev6KTc&cx=c01fea9486d8d4545&q=test&searchType=image
 * 
 */

const GoogleCustomSearch = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  const handleSearch = async () => {
    try {
      const res = await axios.get('https://www.googleapis.com/customsearch/v1', {
        params: {
          key: API_KEY,
          cx: CX,
          q: query,
          searchType: 'image', // Use 'image' to get image results
        },
      });
      console.log("GoogleCustomSearch API : ",res.data);
      setResults(res.data.items || []);
    } catch (err) {
      console.error('Error fetching results:', err);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* <h2>Image Search</h2> */}
      <input
        type="text"
        value={query}
        placeholder="Type your search..."
        onChange={(e) => setQuery(e.target.value)}
        style={{ padding: '8px', width: '300px', marginRight: '10px' }}
      />
      <button onClick={handleSearch}>Search</button>

      <div style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
        {results.map((item, index) => (
          <div key={index}>
            <img src={item.link} alt={item.title} style={{ width: 200 }} />
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoogleCustomSearch;
